import { API_ENDPOINTS } from "@/constants/endpoints";
import type { CreateAccountRequest, CreateAccountResponse, LoginRequest, LoginResponse, AddAuthorizedSignatoryRequest, AddAuthorizedSignatoryResponse } from "@/types/auth";
import { authApi, authLogoutApi } from "../api";
import { COOKIE_NAMES } from "@/constants/auth";
import { getCookie } from "@/utils/cookies";
import { getUserIdFromToken } from "@/utils/authUtils";

const appId = "BUILDER"; // Default appId for all auth requests, can be overridden by passing in the request body

export const loginApi = async (data: LoginRequest): Promise<LoginResponse> => {
    const res = await authApi.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, { ...data, appId });
    return res.data;
};

export const createAccountApi = async (data: CreateAccountRequest): Promise<CreateAccountResponse> => {
    const res = await authApi.post<CreateAccountResponse>(API_ENDPOINTS.AUTH.SIGNUP, { ...data, appId });
    return res.data;
};

export const authorizedSignatoryApi = async (data: AddAuthorizedSignatoryRequest): Promise<AddAuthorizedSignatoryResponse> => {
    const userId = getUserIdFromToken(getCookie(COOKIE_NAMES.ACCESS_TOKEN));
    const res = await authApi.post<AddAuthorizedSignatoryResponse>(API_ENDPOINTS.AUTH.ADDAUTHORIZEDSIGNATORY, { ...data, userId: userId ? Number(userId) : undefined });
    return res.data;
};

export const sendOtpApi = async (data: any): Promise<any> => {
    const res = await authApi.post<any>(API_ENDPOINTS.AUTH.SENDOTP, data);
    return res.data;
};

export const verifyOtpApi = async (data: any): Promise<any> => {
    const res = await authApi.post<any>(API_ENDPOINTS.AUTH.VERIFYOTP, { ...data, appId});
    return res.data;
};

export const forgotPasswordApi = async (data: any): Promise<any> => {
    const res = await authApi.post<any>(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, data);
    return res.data;
};

export const resetPasswordApi = async (data: any): Promise<any> => {
    const res = await authApi.post<any>(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);
    return res.data;
};

export const logoutApi = async () => {
    const res = await authLogoutApi.post(API_ENDPOINTS.AUTH.LOGOUT);
    return res.data;
};
